import React from 'react';
import Sidebar from 'react-sidebar';

import StartScreen from './start-screen/StartScreen';
import InfoScreen from './info-screen/InfoScreen';
import CoursesScreen from './courses-screen/CoursesScreen';
import FaqScreen from './faq-screen/FaqScreen';
import ConnectScreen from './connect-screen/ConnectScreen';
import DesktopFooter from '../footer/DesktopFooter';

import SidebarContent from '../../common/sidebar/SidebarContent';
import useSidebar from '../../common/sidebar/useSidebar';

// import CookiePolicy from '../../common/cookie-policy/CookiePolicy';

import { getDesktopSidebarStyles } from '../../../utils/sidebar-utils';

const Main = () => {
  const { isSidebarOpen, setIsSidebarOpen, openSidebar, closeSidebar } = useSidebar();

  return (
    <>
      <Sidebar
        open={isSidebarOpen}
        onSetOpen={setIsSidebarOpen}
        sidebar={<SidebarContent closeSidebar={closeSidebar} />}
        styles={getDesktopSidebarStyles()}
      >
        <StartScreen openSidebar={openSidebar} />
        <InfoScreen />
        <CoursesScreen />
        <FaqScreen />
        <ConnectScreen />
        <DesktopFooter isPrimary />
      </Sidebar>
      {/* <CookiePolicy /> */}
    </>
  );
};

export default Main;
